export default "__VITE_ASSET__CSX$5Ajh__"